import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import LandingSectionHeader from "./LandingSectionHeader";
import "./LandingProductsSection.css";

const PRODUCTS = [
  {
    icon: <AccountTreeOutlinedIcon />,
    tag: "Сценарий",
    title: "Интерактивное обучение с выбором",
    desc: "Сотрудник принимает решение — и от него зависит, как пойдут события дальше. Реакции могут быть разными в зависимости от ответов. Например, продажник в симуляции общается с клиентом: одни решения ведут к успешной сделке, другие — нет.",
  },
  {
    icon: <MenuBookOutlinedIcon />,
    tag: "База знаний",
    title: "Карманная подсказка вместо забытых инструкций",
    desc: "Зафиксируйте, как вести себя в типичных ситуациях: что ответить, если бариста обвиняют в неправильном кофе, или как работать с новым оборудованием, похожим на старое, но с другими особенностями. Подсказка всегда в кармане.",
  },
  {
    icon: <QuizOutlinedIcon />,
    tag: "Тренажёр",
    title: "Прокачка навыков и мотивация",
    desc: "Инструмент отрабатывает знания на практике и помогает прокачивать скиллы. Можно мотивировать команду: ачивки за прохождение, бонусы за первые места в рейтинге тренажёров — «занимайся, получишь приз».",
  },
];

export default function LandingProductsSection() {
  return (
    <section
      id="platform"
      className="landing-band landing-band--platform landing-section landing-section--products"
    >
      <div className="landing-container">
        <LandingSectionHeader
          label="01 · Возможности"
          title="Что умеет платформа"
          desc="Три формата в одном месте: интерактивное обучение, карманная база знаний и тренажёр. Понятно HR без технического жаргона — всё работает в Telegram или MAX."
        />

        <div className="landing-band__panel landing-band__panel--platform">
          <div className="landing-products-grid">
            {PRODUCTS.map(({ icon, tag, title, desc }) => (
              <article className="landing-product-card" key={tag}>
                <span className="landing-product-card__tag">{tag}</span>
                <div className="landing-product-card__icon">{icon}</div>
                <h3 className="landing-product-card__title">{title}</h3>
                <p className="landing-product-card__desc">{desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
